// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"b3f1154e","787":"f7157b37"}[chunkId] + ".chunk.js";
};